import React from 'react';

function Layout(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M9.25 4.25H4.75C4.47386 4.25 4.25 4.47386 4.25 4.75V9.25C4.25 9.52614 4.47386 9.75 4.75 9.75H9.25C9.52614 9.75 9.75 9.52614 9.75 9.25V4.75C9.75 4.47386 9.52614 4.25 9.25 4.25ZM4.75 3C3.7835 3 3 3.7835 3 4.75V9.25C3 10.2165 3.7835 11 4.75 11H9.25C10.2165 11 11 10.2165 11 9.25V4.75C11 3.7835 10.2165 3 9.25 3H4.75Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M9.25 14.25H4.75C4.47386 14.25 4.25 14.4739 4.25 14.75V19.25C4.25 19.5261 4.47386 19.75 4.75 19.75H9.25C9.52614 19.75 9.75 19.5261 9.75 19.25V14.75C9.75 14.4739 9.52614 14.25 9.25 14.25ZM4.75 13C3.7835 13 3 13.7835 3 14.75V19.25C3 20.2165 3.7835 21 4.75 21H9.25C10.2165 21 11 20.2165 11 19.25V14.75C11 13.7835 10.2165 13 9.25 13H4.75Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M19.25 14.25H14.75C14.4739 14.25 14.25 14.4739 14.25 14.75V19.25C14.25 19.5261 14.4739 19.75 14.75 19.75H19.25C19.5261 19.75 19.75 19.5261 19.75 19.25V14.75C19.75 14.4739 19.5261 14.25 19.25 14.25ZM14.75 13C13.7835 13 13 13.7835 13 14.75V19.25C13 20.2165 13.7835 21 14.75 21H19.25C20.2165 21 21 20.2165 21 19.25V14.75C21 13.7835 20.2165 13 19.25 13H14.75Z"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M19.25 4.25H14.75C14.4739 4.25 14.25 4.47386 14.25 4.75V9.25C14.25 9.52614 14.4739 9.75 14.75 9.75H19.25C19.5261 9.75 19.75 9.52614 19.75 9.25V4.75C19.75 4.47386 19.5261 4.25 19.25 4.25ZM14.75 3C13.7835 3 13 3.7835 13 4.75V9.25C13 10.2165 13.7835 11 14.75 11H19.25C20.2165 11 21 10.2165 21 9.25V4.75C21 3.7835 20.2165 3 19.25 3H14.75Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Layout;
